<template>
  <div v-if="$mq == 'sm' || $mq == 'xs'">
    <div id="taCardCarousel" class="carousel slide w-100" data-ride="carousel" data-interval="2000">
      <div class="carousel-inner carousel-inner-breakescape w-100" role="listbox">
        <div v-for="(room, index) in openRooms" class="carousel-item" :class="{ 'active': index === 0}">
          <a :href="route('breakescape.location.room', {location: location, room: room})" class="card text-white bg-dark-gray">
            <img :src="'/img/breakescape/rooms/' + room.nickname + '.jpg'" class="card-img-top breakescape-card-shadow" :alt="room.name + ' Escape Room'">
          </a>
        </div>
        <div v-if="location.slug != 'loughborough'" class="carousel-item">
          <a class="card text-white bg-dark-gray">
            <img :src="'/img/breakescape/rooms/tbc.jpg'" class="card-img-top breakescape-card-shadow" alt="More Escape Rooms coming soon">
          </a>
        </div>
      </div>

      <a class="carousel-control-prev" href="#taCardCarousel" role="button" data-slide="prev">
        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
        <span class="sr-only">Previous</span>
      </a>
      <a class="carousel-control-next" href="#taCardCarousel" role="button" data-slide="next">
        <span class="carousel-control-next-icon" aria-hidden="true"></span>
        <span class="sr-only">Next</span>
      </a>
    </div>
  </div>
  <div v-else>
    <div class="card-deck">
      <a v-for="(room, index) in openRoomsFirstHalf" class="card text-white bg-dark-gray" :href="route('breakescape.location.room', {location: location, room: room})">
        <img :src="'/img/breakescape/rooms/' + room.nickname + '.jpg'" class="bg-white card-img-top breakescape-card-shadow" :alt="room.name + ' Escape Room'">
      </a>
    </div>
    <div class="card-deck my-4">
      <a v-for="(room, index) in openRoomsSecondHalf" class="card text-white bg-dark-gray" :href="route('breakescape.location.room', {location: location, room: room})">
        <img :src="'/img/breakescape/rooms/' + room.nickname + '.jpg'" class="bg-white card-img-top breakescape-card-shadow" :alt="room.name + ' Escape Room'">
      </a>
      <a class="card text-white bg-dark-gray">
        <img :src="'/img/breakescape/rooms/tbc.jpg'" class="card-img-top breakescape-card-shadow" alt="More Escape Rooms coming soon">
      </a>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    location: Object,
    openRooms: Array,
  },

  data() {
    return {
    };
  },

  computed: {
    openRoomsFirstHalf() {
      let num = this.location.slug == 'loughborough' ? 4 : 3;
      return this.openRooms.filter((room, idx) => idx < num);
    },
    openRoomsSecondHalf() {
      let num = this.location.slug == 'loughborough' ? 4 : 3;
      return this.openRooms.filter((room, idx) => idx >= num);
    },
  },

  watch: {

  },

  methods: {

  },
}
</script>
